import { VpnKey } from "@material-ui/icons";
import { Field, Form, Formik } from "formik";
import React from "react";
import { Button, Col, Row, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import * as Yup from "yup";
import {
  changePasswordAction,
  changePasswordActionNew,
} from "./../../actions/UserActions";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordInfo: {
        oldpassword: "",
        newpassword: "",
        confirmpassword: "",
      },
      message: undefined,
      isFailed: undefined,
      isValidationMsg: undefined,
      showLoader: false,
    };
  }

  /**
   * @desc Change passsword api call and set message to show
   * @param {*} values
   * @param {*} resetForm
   */
  changePassword(values, resetForm) {
    this.setState({ showLoader: true });
    let data = {
      username: localStorage.getItem("userName"),
      id: localStorage.getItem("ID"),
      oldpassword: values.oldpassword,
      password: values.newpassword,
    };

    let dataToSend = { data: data };
    this.props.changePasswordActionNew(dataToSend).then((res) => {
      if (res.status === code.OK) {
        this.setState({
          message: "Your password has been updated successfully!",
          isFailed: false,
          passwordInfo: {
            oldpassword: "",
            newpassword: "",
            confirmpassword: "",
          },
          showLoader: false,
        });

        document.getElementById("change-password-form").reset();
        setTimeout(
          function () {
            this.setState({
              message: undefined,
              isFailed: undefined,
            });
          }.bind(this),
          3000
        );
      } else if (res.status == code.BAD_REQUEST) {
        this.setState({
          message: "Your old password is incorrect.",
          isFailed: true,
          isValidationMsg: true,
          showLoader: false,
        });
      } else {
        this.setState({
          message: "Something went wrong, Please try again!",
          isFailed: true,
          showLoader: false,
        });
        setTimeout(
          function () {
            this.setState({
              message: undefined,
              isFailed: undefined,
            });
          }.bind(this),
          3000
        );
      }
    });
  }

  render() {
    return (
      <div className="change-pass">
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div className="change-pass-inner">
          {this.state.message !== undefined && !this.state.isFailed && (
            <Alert variant={!this.state.isFailed ? "success" : "danger"}>
              {this.state.message}
            </Alert>
          )}
          <h2 className="title-blue mb-3">Change Password</h2>
          <Formik
            validateOnBlur={false}
            initialValues={this.state.passwordInfo}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              oldpassword: Yup.string()
                .required("Please enter Old Password")
                .min(6, message.PASSWORD_LENGTH)
                .matches(/^\S*$/, message.ENTER_VALID_PASSWORD),
              newpassword: Yup.string()
                .required("Please enter New Password")
                .min(6, message.PASSWORD_LENGTH)
                .matches(/^\S*$/, message.ENTER_VALID_PASSWORD),
              confirmpassword: Yup.string()
                .required(message.CONFIRM_PASSWORD)
                .oneOf([Yup.ref("newpassword"), null], message.CONFIRM_PASSWORD_MATCH),
            })}
            onSubmit={(values, { setSubmitting }) => {
              this.changePassword(values);
            }}
          >
            {({ errors, values }) => (
              <Form id="change-password-form">
                <div className="form-group">
                  <label className="form-label" htmlFor="email">
                    Old Password<span className="text-danger"> *</span>
                  </label>
                  <div className="icon-wrapper input-group">
                    <Field
                      name="oldpassword"
                      type="password"
                      value={values.oldpassword}
                      className={"form-control form-control-lg"}
                    />
                    <span className="form-control-icn">
                      <VpnKey />
                    </span>
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.oldpassword}
                    </div>
                    {this.state.message !== undefined &&
                      this.state.isValidationMsg && (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {this.state.message}
                        </div>
                      )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="email">
                    New Password<span className="text-danger"> *</span>
                  </label>
                  <div className="icon-wrapper input-group">
                    <Field
                      name="newpassword"
                      type="password"
                      value={values.newpassword}
                      className={"form-control form-control-lg"}
                    />
                    <span className="form-control-icn">
                      <VpnKey />
                    </span>
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.newpassword}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="email">
                    Confirm Password<span className="text-danger"> *</span>
                  </label>
                  <div className="icon-wrapper input-group">
                    <Field
                      name="confirmpassword"
                      type="password"
                      value={values.confirmpassword}
                      className={"form-control form-control-lg"}
                    />
                    <span className="form-control-icn">
                      <VpnKey />
                    </span>
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.confirmpassword}
                    </div>
                  </div>
                </div>

                <div className="form-group pt-2 mb-2">
                  <Row>
                    <Col xs="6">
                      <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        block
                        className="btn-blue btn-medium"
                      >
                        Change
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isPasswordChanged: state.reducer.isPasswordChanged,
  };
};

export default connect(mapStateToProps, {
  changePasswordAction,
  changePasswordActionNew,
})(ChangePassword);
